Cm.defaults = {
    menu: {
        toggleEl: '.header__menu___uadcm',
        targetEl: '.header__navigation___3RjrQ',
        activeClass: 'header__navigationOpen___Eps9R',
        overlayClass: '.overlay__overlay___2AEOP',
        width: {
            expandMin: 1020,
        },
    },
    forms: {
        subscribe: {
            el: '#frm-site-subscribe',
            loaderEl: '.newsletterLoading__loading',
        },
        errorClass: '.newsletter__errorMessage',
        patterns: {
            email: /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            phone: /^[0-9\-\(\)\s]+/,
        },
    },
    slick: {
        settings: {
            centerMode: true,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            infinite: true,
            speed: 500,
            autoplaySpeed: 3000,
            rows: 0,
            variableWidth: true,
            arrows: true,
            prevArrow:'',
            autoplay: false,
            nextArrow:'<div class="slider__arrow___3hLa9 slider__arrow__left"></div><div class="slider__arrow___3hLa9 slider__arrow__right"></div>',
            responsive: [{
                breakpoint: 768,
                settings: {
                    arrows: true,
                    centerMode: true,
                    slidesToShow: 1,
                }
            }, {
                breakpoint: 480,
                settings: {
                    arrows: true,
                    centerMode: true,
                    slidesToShow: 1
                }
            }]
        }
    },
    map: {
        icon: wp.asset_path + '/plugins/leaflet/images/camdenmarket-map-pin.png',
    }
};